module.exports = __webpack_public_path__ + "img/B2P_Spanish_PrimaryLockup_GreenNavy.7c22b45f.png";